import {
  CustomColorTheme,
  ThemeColorCategory,
} from "../../resources/modelTypes";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";
import mapValues from "lodash/mapValues";
import omitBy from "lodash/omitBy";

// Delete all color field keys so that we only need to set the base minimum colors
// This avoids us needing to find every possible nested scope and override
const deepOmitColorProps = (obj: any) => {
  if (isArray(obj)) {
    // Apply deep omit to each object in array
    return obj.map(deepOmitColorProps);
  }

  if (isObject(obj)) {
    // Remove color fields
    const filtered = omitBy(obj, (value, key) =>
      [
        "backgroundColor",
        "buttonColor",
        "fontColor",
        "linkColor",
        "linkActiveColor",
      ].includes(key),
    );

    // Check any nested fields as well
    return mapValues(filtered, deepOmitColorProps);
  }

  return obj;
};

export const applyCustomColorOverrides = (
  dekuraData: any,
  colorway: string,
  colorTheme: CustomColorTheme,
) => {
  // Create a new object with color properties removed instead of modifying the original
  const cleanedDekuraData = deepOmitColorProps(dekuraData);

  // Even though the data may have multiple colorways, we only need to fill in
  // the currently selected one with the colors
  cleanedDekuraData.DesignProvider.scopes[`Colorway${colorway}`].rules = {
    ...cleanedDekuraData.DesignProvider.scopes[`Colorway${colorway}`].rules,
    backgroundColor: colorTheme[ThemeColorCategory.background],
    fontColor: colorTheme[ThemeColorCategory.text],
    linkColor: colorTheme[ThemeColorCategory.linkAndButtonText],
  };

  cleanedDekuraData.Navbar.scopes.Top.scopes[`Colorway${colorway}`].rules = {
    ...cleanedDekuraData.Navbar.scopes.Top.scopes[`Colorway${colorway}`].rules,
    backgroundColor: colorTheme[ThemeColorCategory.secondaryBackground],
    linkColor: colorTheme[ThemeColorCategory.secondaryText],
  };

  cleanedDekuraData.Navbar.scopes.Inline.scopes[`Colorway${colorway}`].rules = {
    ...cleanedDekuraData.Navbar.scopes.Inline.scopes[`Colorway${colorway}`]
      .rules,
    backgroundColor: colorTheme[ThemeColorCategory.secondaryBackground],
    linkColor: colorTheme[ThemeColorCategory.secondaryText],
  };

  cleanedDekuraData.IntroContainer.scopes[`Colorway${colorway}`].rules = {
    ...cleanedDekuraData.IntroContainer.scopes[`Colorway${colorway}`].rules,
    backgroundColor: colorTheme[ThemeColorCategory.secondaryBackground],
    fontColor: colorTheme[ThemeColorCategory.secondaryText],
  };

  cleanedDekuraData.Button.scopes[`Colorway${colorway}`].rules = {
    ...cleanedDekuraData.Button.scopes[`Colorway${colorway}`].rules,
    buttonColor: colorTheme[ThemeColorCategory.linkAndButtonText],
  };

  return cleanedDekuraData;
};
